const adminSistemaMenu = [
  
  { title: "Módulo Caja",
    tipo: "dropdown",
    sections: [{
      name: "Acciones de caja",
      options: [
        { name: "Cobro de cuotas de afiliados", path:  `/admin/${encodeURIComponent("pago-cuotas")}/1` },
        { name: "Gestión de Recibos de Ingresos", path: "/admin/otros-ingresos"  },
        { name: "Venta de valorados", path: "/admin/valorado-vens" },
        { name: "Compra de valorados", path: "/admin/valorado-dets" },
        { name: "Apertura/cierre diario de Caja", path: "/admin/caja-diarias"}
      ]
    },
    {
      name: "Datos operativos",
      options: [
        { name: "Lista de otros Ingresos", path: "/admin/ingresos-varios"},
  
      ]
    }]
   },
  { title: "Módulo Afiliación",
    tipo: "dropdown",
    sections: [{
    name: "",
      options: [
        { name: "Gestión afiliados", path: "/admin/afiliados" },
        { name: "Inscripciones", path: "/admin/inscripciones" },
        { name: "Seguimiento de situación de afiliados", path: "/admin/seguimiento-situacion-afiliados" },
           ],   
    },{
      name: "Datos operativos",
        options: [
            { name: "Gestión situaciones", path: "/admin/situaciones" },
          { name: "Gestión Requisitos de Inscripción", path: "/admin/requisitos" },
        ],   
      }]
  },
  { title: "Gestión de Cuotas", 
    tipo: "dropdown",
    sections: [{
      name: "",
    options: [
      { name: "Estado de cuentas", path:  `/admin/${encodeURIComponent("pago-cuotas")}/2` },
      { name: "Generación de Cuotas", path:  "/admin/generar-cuotas" },
      { name: "Seguimiento de Pagos", path: "/admin/lugares" },
      { name: "Generación Reportes de Cuotas", path: "/admin/instituciones" },

    ],
  }]
  },
 
  { title: "Propiedad intelectual", 
    tipo: "dropdown",
    sections: [{
      name: "Proyectos",
      options: [
        { name: "Proyectos", path: "/admin/proyectos" },
        { name: "Tipos de proyecto", path: "/admin/tipos-proyecto" },
        { name: "Tipologías por categoría y rubro", path: "/admin/tipologias" },  
        { name: "Rubros", path: "/admin/rubros-proyecto" },
        { name: "Categorías", path: "/admin/categorias" },
      ],
    },
    // {
    //   name: "Propiedad intelectual",
    //   options: [
    //     { name: "Registro de propiedad intelectual", path: "/admin/proyectos" },
    //     { name: "Resellado y modificación de inscripciones de Propiedad Intelectual", path: "/admin/proyectos" },
    //     { name: "Generación de recibos y contabilización", path: "/admin/proyectos-construccion" },
    //   ],
    // },
    {
      name: "Bienes Inmuebles",
      options: [
        { name: "Inmuebles", path: "/admin/inmuebles", icon:'bi bi-house' },
        //{ name: "Propietarios", path: "/admin/propietarios" },
      ],
    },]
    
   

  },
  { title: "Contabilidad", 
    tipo: "dropdown",
    sections: [{
      name: "",
      options: [
      { name: "Gestión de caja", path: "/admin/tipos-proyecto" },
      { name: "Gestión de Comprobantes", path: "/admin/comprobantes" },
      { name: "Balance General", path: "/admin/balance-general" },
      { name: "Gestión Otros Ingresos", path: "/admin/otros-ingresos" },
      { name: "Gestión General de la contabilidad", path: "/admin/proyectos-construccion" },
      { name: "Gestión de Plan de Cuentas", path: "/admin/plan-cuentas" },
      { name: "Cierre y Apertura de Gestión", path: "/admin/proyectos-construccion" },
      { name: "Registro de Bancos", path: "/admin/bancos" },
    ],
  }]
  } ,{
    title: "Administración Sistema",
    tipo: "dropdown",
    sections: [{
      name: "Usuarios y personas",
      options: [
        { name: "Gestión Personas", path: "/admin/personas" },
        { name: "Gestión Usuarios", path: "/admin/usuarios" },
        { name: "Gestión Roles", path: "/admin/roles" }
      ],
    },
    {
      name: "Datos geográficos",
      options: [
        { name: "Gestión Zonas", path: "/admin/paises" },
        { name: "Gestión Lugares", path: "/admin/lugares" },
        { name: "Gestión Regiones", path: "/admin/lugares" },
        { name: "Gestión Países", path: "/admin/paises" },
      ],
    },    {
      name: "Sistema",
      options: [
        { name: "Backup del Sistema", path: "/admin/instituciones" },
      ],
    }]
  },
   { title: "Recursos Operativos", 
    tipo: "dropdown",
    sections: [{
      name: "",
      options: [
        { name: "Gestión Valorados", path: "/admin/valorados" },
        { name: "Gestión Instituciones", path: "/admin/instituciones" },
      ],
    }]
  }
];

export default adminSistemaMenu;

